import { render, staticRenderFns } from "./TheNewHeader.vue?vue&type=template&id=c018b0a0&scoped=true&"
import script from "./TheNewHeader.vue?vue&type=script&lang=js&"
export * from "./TheNewHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheNewHeader.vue?vue&type=style&index=0&id=c018b0a0&scoped=true&lang=scss&"
import style1 from "./TheNewHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c018b0a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheRadarIcon: require('/web/components/TheRadarIcon.vue').default})
